// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textDecoration{text-decoration:underline;color:#44bd32!important;padding:0 5px}", ""]);
// Exports
module.exports = exports;
